module.exports = __webpack_public_path__ + "media/images/photography/ty-designs-cdc24a9d2cdddf480e4420c1b1499f42.jpg";